import { Component, Input, OnInit } from "@angular/core";
import { Store } from "@ngxs/store";
import { Navigate } from "src/store/router/router.actions";
import { Platform } from "@ionic/angular";

@Component({
    selector: "app-back-arrow",
    templateUrl: "./back-arrow.component.html",
    styleUrls: ["./back-arrow.component.css"],
    standalone: false,
})
export class BackArrowComponent implements OnInit {
    @Input() url: string;

    public platform: string;

    constructor(
        private store: Store,
        private platformService: Platform
    ) {}

    ngOnInit() {
        this.setPlatform();
    }

    public setPlatform() {
        if (this.platformService.is("ios")) {
            this.platform = "ios";
            return;
        }

        // Using android looks if platform in unknown
        this.platform = "android";
    }

    public navigateBack() {
        if (this.url) {
            const routerArray = this.url.split("/").filter((x) => x !== "");
            routerArray.unshift("employee");
            this.store.dispatch(new Navigate(routerArray));
        }
    }
}
